import React from 'react';
import { USPsProps } from '@honeycomb/ui';
import { TrBrandUSPs } from 'components/USPs';

export function USPs(props: USPsProps): React.JSX.Element {
    return <TrBrandUSPs {...props} />;
}
